/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Artifact_Confirm_DenyInputs */



/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Chat_Artifact_Confirm_DenyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_artifact_confirm_deny = /** @type {((inputs?: Chat_Artifact_Confirm_DenyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Artifact_Confirm_DenyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überspringen")
	return /** @type {LocalizedString} */ ("Skip")
});